import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_markdownit_db791810 from 'nuxt_plugin_markdownit_db791810' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_vuematerial_2c031184 from 'nuxt_plugin_vuematerial_2c031184' // Source: ./vue-material.js (mode: 'all')
import nuxt_plugin_localforage_e5657f4a from 'nuxt_plugin_localforage_e5657f4a' // Source: ./localforage.js (mode: 'client')
import nuxt_plugin_nuxtmq_c54d6c64 from 'nuxt_plugin_nuxtmq_c54d6c64' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_nuxtmatomoplugin353090b2_bbc50724 from 'nuxt_plugin_nuxtmatomoplugin353090b2_bbc50724' // Source: ./nuxt-matomo.plugin.353090b2.js (mode: 'client')
import nuxt_plugin_vuescrollto_40fb4903 from 'nuxt_plugin_vuescrollto_40fb4903' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_apolloplugincd5d3736_dcfae182 from 'nuxt_plugin_apolloplugincd5d3736_dcfae182' // Source: ./apollo.plugin.cd5d3736.js (mode: 'all')
import nuxt_plugin_router_2faddbae from 'nuxt_plugin_router_2faddbae' // Source: ./router.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_mixins_6f76c2a4 from 'nuxt_plugin_mixins_6f76c2a4' // Source: ../plugins/mixins.js (mode: 'all')
import nuxt_plugin_components_4e0136ac from 'nuxt_plugin_components_4e0136ac' // Source: ../plugins/components.js (mode: 'all')
import nuxt_plugin_veevalidate_3f7cf8b3 from 'nuxt_plugin_veevalidate_3f7cf8b3' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_api_78da0798 from 'nuxt_plugin_api_78da0798' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_elementui_0a43734a from 'nuxt_plugin_elementui_0a43734a' // Source: ../plugins/element-ui.js (mode: 'all')
import nuxt_plugin_portal_6e02f7d8 from 'nuxt_plugin_portal_6e02f7d8' // Source: ../plugins/portal.js (mode: 'all')
import nuxt_plugin_social_59890973 from 'nuxt_plugin_social_59890973' // Source: ../plugins/social.js (mode: 'all')
import nuxt_plugin_modernizrplugin_73921afc from 'nuxt_plugin_modernizrplugin_73921afc' // Source: ../plugins/modernizr-plugin.js (mode: 'all')
import nuxt_plugin_clientinit_31582bdb from 'nuxt_plugin_clientinit_31582bdb' // Source: ../plugins/client-init.js (mode: 'client')
import nuxt_plugin_plausible_24aa3390 from 'nuxt_plugin_plausible_24aa3390' // Source: ../plugins/plausible.js (mode: 'client')
import nuxt_plugin_plausiblewatcher_32b07de9 from 'nuxt_plugin_plausiblewatcher_32b07de9' // Source: ../plugins/plausible-watcher.js (mode: 'client')
import nuxt_plugin_vuefacebooklogin_147695d2 from 'nuxt_plugin_vuefacebooklogin_147695d2' // Source: ../plugins/vue-facebook-login.js (mode: 'client')
import nuxt_plugin_twitch_7d1bef4d from 'nuxt_plugin_twitch_7d1bef4d' // Source: ../plugins/twitch.js (mode: 'client')
import nuxt_plugin_vtooltip_431cebbc from 'nuxt_plugin_vtooltip_431cebbc' // Source: ../plugins/v-tooltip.js (mode: 'client')
import nuxt_plugin_currencyinput_95dfe59c from 'nuxt_plugin_currencyinput_95dfe59c' // Source: ../plugins/currency-input.js (mode: 'client')
import nuxt_plugin_readmore_361826a2 from 'nuxt_plugin_readmore_361826a2' // Source: ../plugins/read-more.js (mode: 'client')
import nuxt_plugin_nuxtquillplugin_3ab6ceae from 'nuxt_plugin_nuxtquillplugin_3ab6ceae' // Source: ../plugins/nuxt-quill-plugin.js (mode: 'client')
import nuxt_plugin_vuesimplephotoswipe_32d58f45 from 'nuxt_plugin_vuesimplephotoswipe_32d58f45' // Source: ../plugins/vue-simple-photoswipe (mode: 'client')
import nuxt_plugin_flashmessage_63972864 from 'nuxt_plugin_flashmessage_63972864' // Source: ../plugins/flash-message.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"the fan platform","titleTemplate":"getnext.to - %s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"getnext.to - the personal community for artists and fans"},{"hid":"og:site_name","property":"og:site_name","content":"getnext.to"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"\u002Fms-icon-144x144.png"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Fandroid-icon-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fapple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fapple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-icon-180x180.png"},{"rel":"manifest","href":"\u002Fmanifest.json"}],"style":[],"script":[{"hid":"nuxt-matomo-js","innerHTML":"window['_paq'] = [];window['_paq'].push(['setTrackerUrl', '\u002F\u002Fmatomo.uscreen.net\u002Fpiwik.php']);window['_paq'].push(['setSiteId', '107']);","type":"text\u002Fjavascript"},{"src":"\u002F\u002Fmatomo.uscreen.net\u002Fpiwik.js","async":true,"defer":true}],"__dangerouslyDisableSanitizersByTagID":{"nuxt-matomo-js":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_db791810 === 'function') {
    await nuxt_plugin_markdownit_db791810(app.context, inject)
  }

  if (typeof nuxt_plugin_vuematerial_2c031184 === 'function') {
    await nuxt_plugin_vuematerial_2c031184(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localforage_e5657f4a === 'function') {
    await nuxt_plugin_localforage_e5657f4a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_c54d6c64 === 'function') {
    await nuxt_plugin_nuxtmq_c54d6c64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtmatomoplugin353090b2_bbc50724 === 'function') {
    await nuxt_plugin_nuxtmatomoplugin353090b2_bbc50724(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_40fb4903 === 'function') {
    await nuxt_plugin_vuescrollto_40fb4903(app.context, inject)
  }

  if (typeof nuxt_plugin_apolloplugincd5d3736_dcfae182 === 'function') {
    await nuxt_plugin_apolloplugincd5d3736_dcfae182(app.context, inject)
  }

  if (typeof nuxt_plugin_router_2faddbae === 'function') {
    await nuxt_plugin_router_2faddbae(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_6f76c2a4 === 'function') {
    await nuxt_plugin_mixins_6f76c2a4(app.context, inject)
  }

  if (typeof nuxt_plugin_components_4e0136ac === 'function') {
    await nuxt_plugin_components_4e0136ac(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_3f7cf8b3 === 'function') {
    await nuxt_plugin_veevalidate_3f7cf8b3(app.context, inject)
  }

  if (typeof nuxt_plugin_api_78da0798 === 'function') {
    await nuxt_plugin_api_78da0798(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_0a43734a === 'function') {
    await nuxt_plugin_elementui_0a43734a(app.context, inject)
  }

  if (typeof nuxt_plugin_portal_6e02f7d8 === 'function') {
    await nuxt_plugin_portal_6e02f7d8(app.context, inject)
  }

  if (typeof nuxt_plugin_social_59890973 === 'function') {
    await nuxt_plugin_social_59890973(app.context, inject)
  }

  if (typeof nuxt_plugin_modernizrplugin_73921afc === 'function') {
    await nuxt_plugin_modernizrplugin_73921afc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientinit_31582bdb === 'function') {
    await nuxt_plugin_clientinit_31582bdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plausible_24aa3390 === 'function') {
    await nuxt_plugin_plausible_24aa3390(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plausiblewatcher_32b07de9 === 'function') {
    await nuxt_plugin_plausiblewatcher_32b07de9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefacebooklogin_147695d2 === 'function') {
    await nuxt_plugin_vuefacebooklogin_147695d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_twitch_7d1bef4d === 'function') {
    await nuxt_plugin_twitch_7d1bef4d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_431cebbc === 'function') {
    await nuxt_plugin_vtooltip_431cebbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_currencyinput_95dfe59c === 'function') {
    await nuxt_plugin_currencyinput_95dfe59c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_readmore_361826a2 === 'function') {
    await nuxt_plugin_readmore_361826a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtquillplugin_3ab6ceae === 'function') {
    await nuxt_plugin_nuxtquillplugin_3ab6ceae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesimplephotoswipe_32d58f45 === 'function') {
    await nuxt_plugin_vuesimplephotoswipe_32d58f45(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flashmessage_63972864 === 'function') {
    await nuxt_plugin_flashmessage_63972864(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
